<template>
    <div class="imgscrollbox" @mouseover="movePause" @mouseout="moveGoon">
        <ul class="flexbox imgbox" :style="{left: ulLeft + 'px'}">
            <li v-for="(item, index) in imglist" :key="index" @click="toDetail(index)">
                <div class=""><img :src="item.MGM_GOODSPIC_MAIN"></div>
                <p>{{item.MGM_LONG_DESC}}</p>
            </li>
        </ul>
    </div>
</template>

<script>
    import { ref, reactive, toRefs, onMounted, onUnmounted, computed, watch } from 'vue'
    import { useRouter } from 'vue-router'

    export default {
        name: 'ImgScroll',
        props: {
            goodsimglist: {
                type: Array,
                required: true
            }
        },
        setup(props, context) {
            let router = useRouter()
            let propsImgList = reactive({
                imglist: props.goodsimglist.concat(props.goodsimglist)
            })
            watch(props, (newProps, oldProps) => {
                if(newProps.goodsimglist.length > 5) {
                    propsImgList.imglist = newProps.goodsimglist.concat(newProps.goodsimglist)
                }else {
                    propsImgList.imglist = newProps.goodsimglist
                }
                
            })
            let ulWidth = ref('')
            let ulLeft = ref(0)
            let ulTime = ref(null)
            // 图片滚动
            let toMove = () => {
                if(propsImgList.imglist.length > 5) {
                    ulWidth.value = (148 * propsImgList.imglist.length) + 'px'
                    ulTime.value = setInterval(() => {
                        ulLeft.value --
                        if(ulLeft.value < -148 * propsImgList.imglist.length/2) {
                            ulLeft.value = 0
                        }
                    }, 40);
                }else {
                    clearInterval(ulTime.value)
                    ulTime.value = null
                }
            }
            let movePause = () => {
                clearInterval(ulTime.value)
                ulTime.value = null
            }
            let moveGoon = () => {
                toMove()
            }
            // 跳转详情
            let toDetail = (idx) => {
                router.push({
                    name: 'ProductDetails',
                    query: {
                        pz: propsImgList.imglist[idx].MGM_GOODS_JPPZID,
                        cz: propsImgList.imglist[idx].MGM_GOODS_CZID,
                        xs: propsImgList.imglist[idx].MGM_GOODS_XSISSPLIT,
                        field:propsImgList .imglist[idx].FIELD,
                                
                                     
                    }
                })
            }
            onMounted(() => {
                toMove()
            })
            onUnmounted(() => {
                clearInterval(ulTime.value)
                ulTime.value = null
            })
            return {
                ...toRefs(propsImgList),
                ulWidth,
                ulLeft,
                ulTime,
                toMove,
                toDetail,
                movePause,
                moveGoon
            }
        }
    }
</script>

<style scoped lang="scss">
    .imgscrollbox {
        width: 890px;
        height: 200px;
        overflow: hidden;
        position: relative;
        .imgbox {
            position: absolute;
            z-index: 99;
            top: 0;
            justify-content: flex-start;
            li {
                padding: 10px 9px;
                width: 148px;
                cursor: pointer;
                div {
                    
                    width: 130px;
                    height: 120px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    img {
                        width: 120px;
                        height: 120px;
                    }
                }
                p {
                    font-size: 12px;
                    margin-top: 10px;
                    text-align: center;
                    height: 48px;
                    overflow: hidden;
                }
            }
        }
    }
</style>
